// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"HomeView","86":"CoursesView","132":"PolicyView","372":"CourseView","373":"RulesView","705":"ContactsView","741":"PaymentSecure"}[chunkId] + "." + {"32":"5ddcf9d0","86":"1fff8951","132":"4ae01f01","372":"8b8cb224","373":"a9434444","705":"26e8648f","741":"a83cbeb6"}[chunkId] + ".css";
};